import { ISpeaker } from 'components/Speaker'
import lucas from 'public/speakers/lucas.jpg'
import monique from 'public/speakers/monique.jpg'
import brock from 'public/speakers/brock.jpg'
import dot from 'public/speakers/dot.jpg'
import angela from 'public/speakers/angela.jpg'
import ashley from 'public/speakers/ashley.jpg'
import konstantinos from 'public/speakers/konstantinos.jpg'
import lauren from 'public/speakers/lauren.jpg'
import mike from 'public/speakers/mike.jpg'
import trilce from 'public/speakers/trilce.jpg'
import christos from 'public/speakers/christos.jpg'
import mario from 'public/speakers/mario.jpg'
import mackensie from 'public/speakers/mackensie.jpg'
import lattice from 'public/speakers/lattice.jpg'
import molly from 'public/speakers/molly.jpg'
import kelly from 'public/speakers/kelly.jpg'
import seth from 'public/speakers/seth.jpg'
import jaclyn from 'public/speakers/jaclyn.jpg'
import candace from 'public/speakers/candace.jpg'
import jenn from 'public/speakers/jenn.jpg'
import charlene from 'public/speakers/charlene.jpg'
import mikeyan from 'public/speakers/mikeyan.jpg'
import wonji from 'public/speakers/wonji.jpg'
import brian from 'public/speakers/brian.jpg'
import natalie from 'public/speakers/natalie.jpg'
import sue from 'public/speakers/sue.jpg'
import anna from 'public/speakers/anna.jpg'

import lucasPng from 'public/speakers/lucas.png'
import moniquePng from 'public/speakers/monique.png'
import brockPng from 'public/speakers/brock.png'
import dotPng from 'public/speakers/dot.png'
import angelaPng from 'public/speakers/angela.png'
import ashleyPng from 'public/speakers/ashley.png'
import konstantinosPng from 'public/speakers/konstantinos.png'
import laurenPng from 'public/speakers/lauren.png'
import mikePng from 'public/speakers/mike.png'
import trilcePng from 'public/speakers/trilce.png'
import christosPng from 'public/speakers/christos.png'
import marioPng from 'public/speakers/mario.png'
import mackensiePng from 'public/speakers/mackensie.png'
import latticePng from 'public/speakers/lattice.png'
import mollyPng from 'public/speakers/molly.png'
import kellyPng from 'public/speakers/kelly.png'
import sethPng from 'public/speakers/seth.png'
import jaclynPng from 'public/speakers/jaclyn.png'
import candacePng from 'public/speakers/candace.png'
import jennPng from 'public/speakers/jenn.png'
import charlenePng from 'public/speakers/charlene.png'
import mikeyanPng from 'public/speakers/mikeyan.png'
import wonjiPng from 'public/speakers/wonji.png'
import brianPng from 'public/speakers/brian.png'
import nataliePng from 'public/speakers/natalie.png'
import suePng from 'public/speakers/sue.png'
import annaPng from 'public/speakers/anna.png'

const speakers: Record<string, ISpeaker> = {
  angela: {
    photo: angela,
    photoPng: angelaPng,
    firstName: 'Angela',
    lastName: 'Allan',
    role: 'Founder of Mads Collective Group & Queen of Giving Good Copy',
    instagram: 'MissSoot',
    bio: 'Angela Allan is an award-winning journalist turned copywriter and marketing consultant whose strategies have helped clients generate $10k revenue in 48 hours. She’s written for Rolling Stone, FHM, and Australian Penthouse. Angela has been featured on School of Bots, Sumo.com, the Chat Marketing podcast, and ManyChat’s blog. You can follow her on Instagram.',
    slug: 'angela-allan',
  },
  anna: {
    photo: anna,
    photoPng: annaPng,
    firstName: 'Anna',
    lastName: 'Tutckaia',
    role: 'Head of Marketing at ManyChat',
    instagram: 'annatutckaia',
    bio: 'Meet Anna Tutckaia: she’s a self-made marketing maven, a dynamic mother of two, and an international entrepreneur who’s run successful businesses on two continents. Now as Head of Digital Marketing at ManyChat, the world’s leading chat marketing platform, she’s helping to reshape the marketing strategies of nearly two million businesses around the world.',
    slug: 'anna-tutckaia',
  },
  ashley: {
    photo: ashley,
    photoPng: ashleyPng,
    firstName: 'Ashley',
    lastName: 'Ann',
    role: 'Biz Builder, Social Media Strategist & TEDx Speaker',
    bio: 'Ashley Ann, also known as King Ashley Ann is a talented biz builder, public speaker, and social media strategist. Ashley has helped over 11,000 individuals monetize their social media and over 700 people create 6 figure incomes. She has currently helped 151 people create 7 figure incomes and 9 of her clients are consistently doing million-dollar months. She has also helped over 1000 businesses generate $25K- $45K per month using Live Stream.',
    slug: 'ashley-ann',
  },
  brian: {
    photo: brian,
    photoPng: brianPng,
    firstName: 'Brian',
    lastName: 'Donnelly',
    role: 'Product Marketing Lead, Business Messaging',
    bio: 'A CX technology product leader, Brian Donnelly is an advocate for business messaging as the future of customer engagement. As Product Marketing Lead, Business Messaging at Meta, he helps businesses grow by delivering better, more efficient experiences across customer journeys over messaging apps.',
    slug: 'brian-donnelly',
  },
  brock: {
    photo: brock,
    photoPng: brockPng,
    firstName: 'Brock',
    lastName: 'Johnson',
    role: 'CEO of InstaClubHub',
    instagram: 'Brock11johnson',
    bio: 'Brock Johnson is a 24-year-old, 7-figure entrepreneur with a passion for helping others grow their following and business on Instagram. As Co-host of a top 10 business Podcast, instructor of multiple online courses, and viral social media creator, Brock has helped thousands of entrepreneurs learn to build their business on social media, even with limited time and money.',
    slug: 'brock-johnson',
  },
  candace: {
    photo: candace,
    photoPng: candacePng,
    firstName: 'Candace',
    lastName: 'Junée',
    role: 'Business Coach & Digital Marketing Strategist',
    instagram: 'CandaceJunee',
    bio: 'Candace Junée is a Chicago-based digital marketing strategist & business coach who has helped over 2,400 entrepreneurs build successful businesses through her Learn Market Grow Digital Academy. She spends her days helping service providers master digital marketing and scale their businesses to 6-Figures and beyond.',
    slug: 'candace-junee',
  },
  charlene: {
    photo: charlene,
    photoPng: charlenePng,
    firstName: 'Charlene',
    lastName: 'Ormo',
    role: 'Co-founder and CEO of After Click Media',
    instagram: 'charleneormo',
    bio: "Charlene Ormo is a Chatbot Marketing Expert to multi-million dollar businesses. With her mission to help 7+ figure businesses make more money and dominate their market, she co-founded After Click Media. It's a digital marketing agency that helps businesses flood their pipeline with leads in record breaking time.",
    slug: 'charlene-ormo',
  },
  christos: {
    photo: christos,
    photoPng: christosPng,
    firstName: 'Christos',
    lastName: 'Nikas',
    role: 'Content Strategist',
    instagram: 'thechristosnikas',
    bio: 'Christos is a content strategist, coach, speaker, and owner of multiple businesses. He works with service & knowledge-based businesses worldwide, turning their Social Media accounts into memorable (personal) brands. Get ready to transform your ordinary content into a powerhouse of growth, influence, impact, new leads, and income.',
    slug: 'christos-nikas',
  },
  dot: {
    photo: dot,
    photoPng: dotPng,
    firstName: 'Dot',
    lastName: 'Lung',
    role: 'Mother of Social Dragons',
    instagram: 'dotlung',
    bio: 'With over 125,000 students or “baby dragons” around the world, Dot Lung, or aka “The Mother of Social Dragons” empowers creatives to use the power of social media to grow careers and businesses. She works on global campaigns with clients like Meta, Facebook, Wix, Motionographer, Digital Design Days, and many more.',
    slug: 'dot-lung',
  },
  jaclyn: {
    photo: jaclyn,
    photoPng: jaclynPng,
    firstName: 'Jaclyn',
    lastName: 'Johnson',
    role: 'Founder and CEO of Create & Cultivate',
    instagram: 'jaclynrjohnson',
    bio: "Jaclyn Johnson is a powerhouse entrepreneur, author, investor, podcast host and business owner. She is the CEO of Create & Cultivate, which gathers the best and the brightest female entrepreneurs and CEOs in online and in-person conferences to help educate & facilitate young women in today’s working world. Create & Cultivate reaches an audience of 1 million millennial women, and has hosted over 100 events to date. The conferences boast sponsors that include top Fortune 500 companies like Mastercard, Facebook Messenger, Amazon, LinkedIn, QuickBooks and Microsoft to the buzziest brand names like LaCroix, Clinique, Chandon, Urban Outfitters and more. Past speakers and panelists include celebrities and CEO’s like ​Kim Kardashian West, Martha Stewart, Chelsea Handler, Jessica Alba, Meghan Markle, Chrissy Teigen, Gloria Steinem, Issa Rae, Nicole Richie ​and more front-runners in fashion, technology, design and business. \u000aPrevious to Create & Cultivate, Jaclyn established and sold her own marketing and influencer agency titled (No Subject) by the time she was 28. Jaclyn has been recognized by Forbes' \"30 Under 30,\" Ad Week Disruptor, A Women Of Note by The Wall Street Journal and more. \u000aJaclyn’s own work-life philosophy, built on the cornerstones of female empowerment, hustling-hard and innovation have propelled her voice to the forefront of the discussion on workplace equality, a new thought-leader for millennial women and Gen Zers on the career come up. Known for her powerful messaging and often imitated never duplicated style of digital and experiential marketing, Johnson is reshaping attitudes on female entrepreneurialism, work culture and the gig economy for women all over the world. \u000aJohnson's first book, ​WorkParty​, offers a rallying cry for women in the workplace, ​First We Leaned In, Now We Stand Up. WorkParty ​is Johnson’s career manifesto sharing her story as well as advice on how she turned distrust into determination, frustration into fuel, and heartache into hard work. WorkParty has an accompanying podcast which has featured guests like ​Kristen Bell, Sophia Bush, Kendra Scott and Shark Tank's Barbara Corcoran and was named to Forbes' 21 Podcasts to Listen to in 2021 list.",
    slug: 'jaclyn-johnson',
  },
  jenn: {
    photo: jenn,
    photoPng: jennPng,
    firstName: 'Jenn',
    lastName: 'Herman',
    role: "Founder of Jenn's Trends",
    instagram: 'jenns_trends',
    bio: 'Jenn Herman is a social media consultant, speaker, and globally recognized Instagram expert. She is the forefront blogger on Instagram marketing and her blog, Jenn’s Trends, has won the title of a Top 10 Social Media Blog over multiple years. She is a sought-after and international speaker providing tips, resources, and training for organizations of all sizes that need to structure their social media strategies. Her business background includes Administration, Sales, Human Resources, and Marketing and she enjoys bringing all these skills together to help you grow your business. Jenn has been featured in Inc., Fox News, BBC News, Yahoo Finance, Entrepreneur, HuffPost, The Verge, CBS Radio LA, and numerous other podcasts and publications. She is the author of “Instagram for Dummies”, “Instagram for Business for Dummies”, “The Ultimate Guide to Social Media Marketing”, and “Stop Guessing: Your Step-by-Step Guide to Creating a Social Media Strategy”.',
    slug: 'jenn-herman',
  },
  kelly: {
    photo: kelly,
    photoPng: kellyPng,
    firstName: 'Kelly Noble',
    lastName: 'Mirabella',
    role: 'Founder of Stellar Media Marketing & Baby Got Bot',
    instagram: 'stellar247',
    bio: 'Award-winning international speaker, content marketing expert, and co-author of Digital Etiquette For Dummies, Kelly has been recognized as a leader in the chat marketing space. Kelly specializes in mentoring and coaching agencies and freelancers to succeed in marketing and business.',
    slug: 'kelly-noble-mirabella',
  },
  konstantinos: {
    photo: konstantinos,
    photoPng: konstantinosPng,
    firstName: 'Konstantinos',
    lastName: 'Synodinos',
    role: 'CEO of Simply Digital',
    instagram: 'simplydigital.gr',
    bio: 'My name is Konstantinos Synodinos and I am a Brand and Digital Marketer for +20 Years, ex P&G & Diageo Regional Marketing Manager, 2 time Winner of the Greek Entrepreneurship award, top 32 entrepreneur by the US Dpt of State in 2016 (GES2016). CEO & Founder of Simply Digital and ChampionsID.com',
    slug: 'konstantinos-synodinos',
  },
  lattice: {
    photo: lattice,
    photoPng: latticePng,
    firstName: 'Lattice',
    lastName: 'Hudson',
    role: 'Founder & CEO Of Lattice & Co.',
    instagram: 'latticehudson',
    bio: 'Lattice is a business coach, leadership mentor and social sales expert. Lattice is on a mission to help women make more money, increase their impact all while living a life that they love. Lattice specializes in helping online coaches start & scale their online coaching business to 6 - 7 figures.',
    slug: 'lattice-hudson',
  },
  lauren: {
    photo: lauren,
    photoPng: laurenPng,
    firstName: 'Lauren',
    lastName: 'Petrullo',
    role: 'Founder & CEO of Award Winning Marketing Agency, Mongoose Media',
    instagram: 'laurenepetrullo',
    bio: "Lauren Petrullo is an award winning marketing expert, digital marketing and ecommerce consultant, and successful multi-founder. She is the CEO and Founder of Marketing Agency Mongoose Media, Founder of Asian Beauty Essentials, Chief Marketing Officer of Beau & Belle Littles, and co-founder of Bot Blondes. Lauren is the winner of Prism’s Top 100 Marketing & Advertising Leaders, Marcom's Advertising & Communication Award, and she has been featured in Yahoo!, The Wrap, Thrive Global, Refinery29, Shopify, Advertising Week, ComputerWorld and TickerNews.",
    slug: 'lauren-petrullo',
  },
  lucas: {
    photo: lucas,
    photoPng: lucasPng,
    firstName: 'Lucas',
    lastName: "O'Keefe",
    role: 'Content Creator and Social Media Strategist',
    instagram: 'thelucasokeefe',
    bio: "Lucas O'Keefe is a content creator and social media strategist who has built a community of over 250K followers across multiple platforms in under two years and Instagram is his favourite of them all! Join Lucas for all the best tips and tricks for how you can do the same for your own brand or business.",
    slug: 'lucas-o-keefe',
  },
  mackensie: {
    photo: mackensie,
    photoPng: mackensiePng,
    firstName: 'Mackensie',
    lastName: 'Liberman',
    role: 'CEO of Orca Marketology',
    instagram: 'mackensieliberman',
    bio: 'Mackensie is one of the top experts in chatbots since 2017 having created chat marketing systems for a wide variety of business niches, from local brick and mortar businesses to multi-million dollar coaches, e-commerce stores, NFT companies, and more! She thoroughly enjoys building chatbots and sharing her knowledge with others.',
    slug: 'mackensie-liberman',
  },
  mario: {
    photo: mario,
    photoPng: marioPng,
    firstName: 'Mario',
    lastName: 'Moreno',
    role: 'Founder & CEO of Moonrise Social Club',
    instagram: 'followmario',
    bio: 'Mario Moreno is a brand marketer with 12 years of experience working for major retail brands – GUESS, Forever 21, L’Oreal USA and H&M. Mario currently owns his own agency, Moonrise Social Club where he consults with brands on how to build modern, results-driven marketing and social media plans.',
    slug: 'mario-moreno',
  },
  mike: {
    photo: mike,
    photoPng: mikePng,
    firstName: 'Mike',
    lastName: 'Nelson',
    role: 'Founder & CEO of The Passion To Profit Coaching',
    instagram: 'ItsMikeNel',
    bio: 'Mike Nelson is an Online Course Creation Coach who shares creative ways to get paying clients through simple ads. His coined “Slide In The DMs” technique revolutionize how Coaches get high paying clients using Instagram.',
    slug: 'mike-nelson',
  },
  mikeyan: {
    photo: mikeyan,
    photoPng: mikeyanPng,
    firstName: 'Mike',
    lastName: 'Yan',
    role: 'Co-Founder & CEO of ManyChat',
    instagram: 'themikeyan',
    bio: 'Mike Yan, co-founder and CEO of ManyChat - the #1 Chat Marketing platform helping over 1 million businesses in 190 countries around the world revolutionize how they communicate with their customers. ManyChat enables businesses to leverage Messenger by Facebook, Instagram Automation, SMS, and email for marketing, sales, and support.',
    slug: 'mike-yan',
  },
  molly: {
    photo: molly,
    photoPng: mollyPng,
    firstName: 'Molly ',
    lastName: 'Mahoney',
    role: 'Founder & CEO of The Prepared Performer',
    instagram: 'thepreparedperformer',
    bio: "Molly is a digital strategist who specializes in creating authentic Facebook video content and leveraging Bots to skyrocket sales. After her video reached one million organically, she developed her signature “Go Live And Monetize” GLAM method. She's been featured in Inc. Magazine and seen speaking at Social Media Marketing World.",
    slug: 'molly-mahoney',
  },
  monique: {
    photo: monique,
    photoPng: moniquePng,
    firstName: 'Monique',
    lastName: 'Lombardo',
    role: 'Founder of The Socialista and Co-Creator of Rise With Reels',
    instagram: 'thesocialista_',
    bio: 'Monique is a Social Media, Reels and Marketing Coach helping businesses create a stellar Instagram presence to become the go-to in their industry and turn their followers into dollars!',
    slug: 'monique-lombardo',
  },
  natalie: {
    photo: natalie,
    photoPng: nataliePng,
    firstName: 'Natalie',
    lastName: 'Ellis',
    role: 'Co-Founder and CEO of BossBabe',
    instagram: 'iamnatalie',
    bio: 'Natalie Ellis is a serial entrepreneur and angel investor, as well as the co-founder and CEO of media brand BossBabe. Under her leadership, BossBabe now reaches more than 20M+ ambitious women per month, and has a community of 5M across their social media, blog, podcast and newsletter. Natalie’s expertise lies in audience growth, content monetization and business strategy. Natalie is passionate about supporting women to take action in creating lives that they’re in love with.',
    slug: 'natalie-ellis',
  },
  seth: {
    photo: seth,
    photoPng: sethPng,
    firstName: 'Seth',
    lastName: 'Godin',
    role: 'Bestselling Author, Teacher, & Entrepreneur',
    instagram: 'sethgodin',
    bio: 'SETH GODIN is the author of 20 books that have been bestsellers around the world and have been translated into more than 35 languages. He’s also the founder of the altMBA and The Akimbo Workshops, online seminars that have transformed the work of thousands of people. He writes about the post-industrial revolution, the way ideas spread, marketing, quitting, leadership and most of all, changing everything. You might be familiar with his books Linchpin, Tribes, The Dip and Purple Cow. His book, This Is Marketing, was an instant bestseller around the world. The newest book, The Practice, is out at the end of 2020 and is already a bestseller. His newest project is leading a worldwide group of volunteers creating The Carbon Almanac. In addition to his writing and speaking, Seth has founded several companies, including Yoyodyne and Squidoo. His blog (which you can find by typing “seth” into Google) is one of the most popular in the world. His podcast is in the top 1% of all podcasts worldwide. In 2018, he was inducted into the Marketing Hall of Fame. More than 20,000 people have taken the powerful Akimbo workshops he founded, including thealtMBA and The Marketing Seminar.',
    slug: 'seth-godin',
  },
  sue: {
    photo: sue,
    photoPng: suePng,
    firstName: 'Sue B.',
    lastName: 'Zimmerman',
    role: 'Founder of Sue B. Zimmerman Enterprise',
    instagram: 'theinstagramexpert',
    bio: 'Sue B. is an insightful, energetic, and in-demand online marketing educator, influencer speaker, and a no-BS business coach. Whether she’s taking a global stage, or speaking at an industry conference, like Social Media Marketing World, or working one-on-one with her clients, Sue B. is driven to help business owners leverage the power of Instagram to meet (and exceed) their business goals. As a lifelong entrepreneur, Sue B. has over 30 years of business experience. And, with her extensive knowledge and implementation of social media, it is Sue B.’s mission to teach, mentor, and empower others.',
    slug: 'sue-b-zimmerman',
  },
  trilce: {
    photo: trilce,
    photoPng: trilcePng,
    firstName: 'Trilce',
    lastName: 'Jirón Garro',
    role: 'CEO of TBS Marketing',
    instagram: 'trilcejiron',
    bio: 'Trilce, founder and CEO of TBS Marketing in Costa Rica, designed Interdepartmental Marketing. By uniting graphic design, marketing, sales CRM, and customer support under one umbrella, she can brag about her company’s unbelievable results for clients such as 3X in sales, 3X in conversion rates and 100% retention rate.',
    slug: 'trilce-jiron-garro',
  },
  wonji: {
    photo: wonji,
    photoPng: wonjiPng,
    firstName: 'Wonji',
    lastName: 'Choi',
    role: 'Product Marketing Manager, Business Messaging',
    instagram: 'w0njic',
    bio: 'Wonji has been leading product marketing for Messenger API for Instagram from the Alpha stage. With her experience managing various marketing channels and strategy, from marketing for startups, strategy and analytics for a CPG company, to leading growth for ventures created by Fortune 500 companies, she’s excited to be supporting businesses and brands as they leverage Instagram Messaging to drive business outcomes.',
    slug: 'wonji-choi',
  },
}

export const mainSpeakers: ISpeaker[] = [
  speakers.jaclyn,
  speakers.seth,
  speakers.brock,
  speakers.dot,
]

export const allSpeakers: ISpeaker[] = Object.values(speakers)
